import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { LogService } from '../services/log.service'
import { AppInitService, AppInitStatus } from '../services/app-init.service'
import { FilterApiService } from '../services/filter-api.service'


export const searchPageGuard: CanActivateFn = async () => {
  const appInitService = inject(AppInitService)
  const logger = inject(LogService)
  const filterApiService = inject(FilterApiService)

  const results = await Promise.allSettled([
    filterApiService.loadFilterSettings(),
  ])
  if (results.some(r => r.status === 'rejected')) {
    logger.fatal('Unable to load required services for search page. ', results)
    appInitService.status.set(AppInitStatus.Error)
    return Promise.resolve(false)
  }

  return Promise.resolve(true)
}
